// Generated by tutorials/record.cjs from tutorials/articles/h50-asking-for-a-menu-change.cjs.
// Do not edit: change the script and run `node tutorials/record.cjs h50 --text-only` (wording) or
// `node tutorials/record.cjs h50` (pictures and clips).
import type { HelpArticle } from '../types';

const article: HelpArticle = {
  slug: 'asking-for-a-menu-change',
  catalogId: 'h50',
  title: 'Asking for a menu change',
  summary: 'Ask PSI to change an item on your menu cycle: pick the day and meal, click the item, say what it should become, and send it. Then follow the request and read PSI\'s reply.',
  audience: 'Dietary managers and cooks who want something on the menu changed',
  area: 'menus',
  learn: [
    'Pick the day and meal, and the item to change',
    'Say what it should change to, with a note',
    'Mark the diets and consistencies, when it matters',
    'Send the request and follow it in Your requests',
  ],
  keywords: [
    'menu change',
    'change request',
    'request a menu change',
    'ask psi',
    'change an item',
    'replace item',
    'substitute',
    'menu request',
    'extensions',
    'diets',
    'consistencies',
    'renal',
    'pureed',
    'no gravy',
    'your requests',
    'status',
    'reply',
    'delete request',
    'cancel request',
    'withdraw request',
  ],
  steps: [
    {
      id: 'open',
      part: 'Ask for a change to one item',
      heading: 'Open Request a Menu Change',
      text: 'Under Menus, select Request a Menu Change.\n\nThe menu cycle in use is picked for you; pick another at the top if the change is for a different cycle. Change an item is selected.',
      media: {
        image: {
          src: '/help/asking-for-a-menu-change/open.webp',
          width: 1280,
          height: 842,
        },
        alt: 'Request a Menu Change with the Fall/Winter Cycle 2026 (in use) menu cycle picked and Change an item selected, above the day and meal buttons.',
      },
    },
    {
      id: 'day',
      part: 'Ask for a change to one item',
      heading: 'Pick the day and the meal',
      text: 'Each button is one day of the cycle, with its weekday under it. The page starts on today and lunch.\n\nSelect the day and the meal the change is for. That meal\'s menu shows underneath, category by category.',
      media: {
        image: {
          src: '/help/asking-for-a-menu-change/day.webp',
          width: 1280,
          height: 916,
        },
        clip: {
          src: '/help/asking-for-a-menu-change/day.mp4',
          width: 1280,
          height: 916,
          durationSec: 2.7,
        },
        alt: 'Day 4 and Lunch selected, with the heading for that meal and its menu under it.',
      },
    },
    {
      id: 'item',
      part: 'Ask for a change to one item',
      heading: 'Click the item and say what it becomes',
      text: 'Click the item you want changed. A box opens under it.\n\nIn Change to, type the new item. When it is in your item list, pick it. When it is not set up yet, just type its name: it is sent as you typed it.',
      media: {
        image: {
          src: '/help/asking-for-a-menu-change/item.webp',
          width: 1280,
          height: 396,
        },
        clip: {
          src: '/help/asking-for-a-menu-change/item.mp4',
          width: 1280,
          height: 396,
          durationSec: 5.3,
        },
        alt: 'The ENTREE item opened, with BEEF POT ROAST picked in Change to and the words From your item list under it.',
      },
    },
    {
      id: 'note',
      part: 'Ask for a change to one item',
      heading: 'Add a note, then Done',
      text: 'Use Note for anything PSI should know about this item, such as the portion.\n\nSelect Done. The item now shows the old name crossed out and the new one beside it, with Change next to it. Undo takes the change back.',
      media: {
        image: {
          src: '/help/asking-for-a-menu-change/note.webp',
          width: 1280,
          height: 96,
        },
        clip: {
          src: '/help/asking-for-a-menu-change/note.mp4',
          width: 1280,
          height: 96,
          durationSec: 6,
        },
        alt: 'The changed item: the old entree crossed out, an arrow, BEEF POT ROAST, the note, the Change tag and Undo.',
      },
    },
    {
      id: 'extensions',
      part: 'When a diet needs something different',
      heading: 'Say if a diet or consistency needs something different',
      text: 'Most changes need nothing here: every diet and consistency gets the new item the way they got the old one.\n\nWhen one needs something else, click the item again, select Add a diet or consistency, pick it from the list, and type what they get, such as No gravy for Renal. Add a line for each one. Select the X to remove a line.',
      media: {
        image: {
          src: '/help/asking-for-a-menu-change/extensions.webp',
          width: 1280,
          height: 548,
        },
        clip: {
          src: '/help/asking-for-a-menu-change/extensions.mp4',
          width: 1280,
          height: 548,
          durationSec: 6,
        },
        alt: 'Two lines under the changed item: Renal gets No gravy, and Pureed gets Pureed pot roast, with Add a diet or consistency under them.',
      },
    },
    {
      id: 'when',
      part: 'Send it',
      heading: 'Say when it applies',
      text: 'Under When, keep Every time this cycle comes around for a lasting change.\n\nFor a single day, such as a special event, pick Just one date and choose the date.',
      media: {
        image: {
          src: '/help/asking-for-a-menu-change/when.webp',
          width: 1280,
          height: 134,
        },
        clip: {
          src: '/help/asking-for-a-menu-change/when.mp4',
          width: 1280,
          height: 134,
          durationSec: 3,
        },
        alt: 'When, with Every time this cycle comes around and Just one date, and the Date box showing under Just one date.',
      },
    },
    {
      id: 'send',
      part: 'Send it',
      heading: 'Add your contact details and send',
      text: 'Add Notes for anything else about the request. Check Phone and Email so PSI can reach you; Email starts as the address you sign in with.\n\nSelect Send request. It stays off until there is something to send, and the words beside it say what is missing.\n\nThe top of the page then says Request sent to PSI, with the request number.',
      media: {
        image: {
          src: '/help/asking-for-a-menu-change/send.webp',
          width: 1280,
          height: 414,
        },
        clip: {
          src: '/help/asking-for-a-menu-change/send.mp4',
          width: 1280,
          height: 414,
          durationSec: 6,
        },
        alt: 'Notes filled in, Phone and Email, and Send request ready to select.',
      },
    },
    {
      id: 'requests',
      part: 'Follow your request',
      heading: 'Follow it in Your requests',
      text: 'Your requests, at the bottom of the page, lists this facility\'s requests, newest first: what was asked, its status and PSI\'s reply.\n\nNew means PSI has not started it. In progress means PSI is working on it. Need more info means PSI\'s reply asks you something. Done means the change is on your menu. Declined means PSI did not make it; the reply says why.\n\nChanged your mind? While a request is still New, select Delete on its row, then Delete again to confirm. PSI won\'t work on it and it leaves the list. Once PSI has started it, there is no Delete; call PSI instead.',
      media: {
        image: {
          src: '/help/asking-for-a-menu-change/requests.webp',
          width: 1280,
          height: 358,
        },
        clip: {
          src: '/help/asking-for-a-menu-change/requests.mp4',
          width: 1280,
          height: 358,
          durationSec: 3.3,
        },
        alt: 'Your requests: the new request at the top with status New, then an earlier swap In progress and an earlier change Done with PSI\'s reply.',
      },
    },
  ],
  tips: [
    'Change several items on the same meal and they all go in one request.',
    'To ask about another meal, send this request first. Picking another day or meal clears the items you marked, and the page asks before it does.',
    'Not sure what the new item is called? Type it in your own words. PSI matches it to an item.',
    'Cancel clears everything you entered, after asking.',
  ],
  notes: [
    'Sending a request does not change your menu. PSI makes the change in your menu cycle and replies in Your requests.',
    'Request a Menu Change is under Menus for facilities that use production. If you do not see it, ask your administrator for Menu Cycle access.',
    'Change Requests, also under Menus, is a different page: it reads the extension sheets your facility marks up and sends back. See Menu Swap and Change Requests.',
  ],
  related: [
    'asking-to-swap-two-meals',
    'reading-a-menu-cycle',
    'menu-swap-and-requests',
    'changing-menu-items',
  ],
  recorded: '2026-11-02',
};

export default article;
